import type { ReactNode } from 'react';

import { cn } from '@/lib/utils/cn';

import { BADGE_TONES, type BadgeTone } from './badge-tones';

interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  className?: string;
}

export const Badge = ({ children, tone = 'neutral', className }: BadgeProps) => (
  <span
    className={cn(
      'inline-flex items-center gap-1 rounded-md border bg-linear-to-b from-white/45 to-transparent px-2 py-0.5 text-[11px] leading-4 font-medium whitespace-nowrap shadow-[inset_0_1px_0_0_rgb(255_255_255/0.8)]',
      BADGE_TONES[tone],
      className,
    )}
  >
    {children}
  </span>
);
